import { Alert, AlertIcon, Box, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeV2QuestionDto, SeV2QuestionStatus } from "../../../../autogen/bff-api";
import { BuyerQuestionCard } from "./BuyerQuestionCard";

export const BuyerQuestionInbox = ({ eventId, questions }: { eventId: string; questions: SeV2QuestionDto[] }) => {
  const { t } = useTranslation();
  const unanswered = questions.filter((q) => q.status === SeV2QuestionStatus.Unanswered).length;

  if (questions.length === 0) {
    return (
      <Box py="10" textAlign="center" color="smMuted">
        <Text>{t("No questions received yet")}</Text>
      </Box>
    );
  }

  return (
    <Stack spacing="4">
      {unanswered > 0 && (
        <Alert status="error" rounded="md" fontSize="sm">
          <AlertIcon />
          {unanswered} {t("unanswered")}
        </Alert>
      )}
      {questions.map((question) => (
        <BuyerQuestionCard key={question.id} eventId={eventId} question={question} />
      ))}
    </Stack>
  );
};
